import { Injectable } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Subject, Subscription } from "rxjs";

@UntilDestroy()
@Injectable({
  providedIn: "root",
})
export class EventsService {

  events: Record<string, Subject<any>> = {};
  constructor() { }

  publish(eventName: string, data?: any) {
    this.createIfNotExists(eventName);
    this.events[eventName].next(data);
  }

  subscribe(eventName: string, callback: (data?) => any) {
    this.createIfNotExists(eventName);
    return this.events[eventName].subscribe((data) => {
      return callback(data);
    });
  }

  subscribeUntilDestroyed(eventName: string, callback: (data?) => any, context: any): Subscription {
    this.createIfNotExists(eventName);
    return this.events[eventName]
      .pipe(
        untilDestroyed(context)
      )
      .subscribe((data) => callback(data));
  }

  private createIfNotExists(eventName: string) {
    if (!this.events[eventName]) {
      this.events[eventName] = new Subject();
    }
  }

  destroy(eventName: string) {
    const event = this.events[eventName];
    if (!event) {
      return;
    }
    event.complete();
    delete this.events[eventName];
  }

  unsubscribe(eventName: string) {
    this.destroy(eventName);
  }
}
